export default __webpack_public_path__ + "static/media/news74.166e0cd7.jpg";